enum PUBLIC_STATUS {
  visible = 'Visible',
  private = 'Private',
}

export { PUBLIC_STATUS }
